import { Link } from 'react-router-dom'
import { EmptyState } from '@/components/states'
import { Button } from '@/components/ui/Button'
import { FileQuestion } from '@/components/icons'

/** Rendered inside the shell so the user can still navigate away. */
export function NotFoundPage() {
  return (
    <EmptyState
      icon={FileQuestion}
      title="Page not found"
      description="That link does not point anywhere in the panel. It may have been renamed, or the record may no longer exist."
      action={
        <Button asChild variant="secondary" size="sm">
          <Link to="/">Back to Overview</Link>
        </Button>
      }
    />
  )
}
